import { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useLeaveTeam } from '@frx/frx-react-context';
import { useNavigate } from 'react-router-dom';
import { useEventId, useIsMobile } from '../../../../hooks';
import { Modal, Notification } from '../../../../components';
import { CloseX, ExclamationMark } from '../../../../assets';
import { getDataTracking, getTeamRaiserErrorMessage } from '../../../../utils';

export const LeaveTeamModal = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const toast = useToast();
  const eventId = useEventId();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { mutate: leaveTeam } = useLeaveTeam();
  const [errorMessage, setErrorMessage] = useState('');

  const onLeaveTeam = () => {
    leaveTeam(
      { fr_id: eventId },
      {
        onSuccess: () => {
          toast({
            title: 'You have left the team',
            status: 'success',
            duration: 2000,
          });
          onClose();
          navigate('/dashboard');
        },
        onError(error) {
          setErrorMessage(
            getTeamRaiserErrorMessage({
              error,
              defaultErrorMessage:
                'Sorry, we are not able to remove you from this team at this moment. Please try again later.',
            })
          );
        },
      }
    );
  };

  return (
    <Box>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setErrorMessage('');
          onClose();
        }}
        buttonProps={{
          w: 'full',
          colorScheme: 'blue',
          variant: 'ghost',
          title: 'Leave Team',
          onClick: onOpen,
          leftIcon: <CloseX />,
        }}
        size={isMobile ? 'xs' : 'xl'}
        modalTitle={
          <Flex>
            <Box mr="1rem">
              <ExclamationMark boxSize="30px" />
            </Box>
            Leave Team
          </Flex>
        }
      >
        <VStack spacing="1.5rem">
          <Heading size="lg" color="brand.primary.swatch1" w="100%">
            Are you sure?
          </Heading>
          {errorMessage && (
            <Notification status="error" message={errorMessage} />
          )}
          <Text>
            A team captain will be required to reinvite you if you decide to
            rejoin the fundraising team
          </Text>
          <Text fontStyle="italic">
            Leaving the team will not impact your personal fundraising amount
          </Text>
          <Button
            w="100%"
            onClick={onLeaveTeam}
            {...getDataTracking('yesLeaveTeamButton')}
          >
            Yes, leave team
          </Button>
          <Text cursor="pointer" fontWeight="bold" onClick={onClose}>
            No, stay on this team
          </Text>
        </VStack>
      </Modal>
    </Box>
  );
};
